export const addDays = (date, days) => {
  const aDayInMs = 8.64e7;
  return new Date(date.getTime() + days * aDayInMs);
};
